import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutomobileService {
  private automobileEndpoint: string =
  'https://entityserver.manikworks.com/automobiles';
  constructor(private http: HttpClient,) { }

  public getAutomobileDetails(queryFilter: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      Operation: 'FETCH.AUTOMOBILE.DATA',
      QueryFilter: queryFilter,
    });
    const options = { headers };
    return this.http.post(this.automobileEndpoint, null, options).pipe();
  }

  public getAutomobileListDetails(queryFilter: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      Operation: 'FETCH.LISTING.DETAILS',
      QueryFilter: queryFilter,
    });
    const options = { headers };
    return this.http.post(this.automobileEndpoint, null, options).pipe();
  }
}
